import { ContractType } from '@/common/graphql';

export const ContractTypeLabels: Record<ContractType, string> = {
  [ContractType.FtPermanent]: 'FT Permanent',
  [ContractType.FtFixedTerm]: 'FT Fixed-term',
  [ContractType.FtFreelancer]: 'FT Freelancer',
  [ContractType.FtConsultant]: 'FT Consultant',
  [ContractType.PartTime]: 'Part Time',
  [ContractType.Intern]: 'Intern',
  [ContractType.Contractor]: 'Contractor',
};

// Feature 032 (2026-07-22 clarification): matches the backend's ContractType.isRehireRecommendationRequired
// scope exactly - now the same set as "full-time" (FtPermanent/FtFixedTerm/FtFreelancer/FtConsultant,
// i.e. every Contract Type whose name begins with "FT_"). Re-hire Recommendation is shown for every
// Contract Type; this only gates whether a value is required before save. See research.md item 6.
export const isRehireRecommendationRequired = (contractType: ContractType | null | undefined): boolean =>
  contractType === ContractType.FtPermanent ||
  contractType === ContractType.FtFixedTerm ||
  contractType === ContractType.FtFreelancer ||
  contractType === ContractType.FtConsultant;
